<template>
    <div class="custom-upload con-img-upload">
        <div class="img-upload con-input-upload" v-for="(item, index) in items" :key="index" :class="{'is-loading': item.loading}">
            <button type="button" class="btn-x-file" :class="{'ignore-no-edit': isDelete}" @click="deleteItem(item,index)" v-if="isDelete">
                <i translate="translate" class="material-icons notranslate"> clear </i>
            </button>

            <img :src="getUrl(item,index)" style="max-width: none; max-height: 100%;" v-if="(/\.(gif|jpe?g|tiff|png|webp|bmp)$/i).test(getUrl(item,index))">
            <div class="text-archive" :class="{'hover': (/\.(gif|jpe?g|tiff|png|webp|bmp)$/i).test(getUrl(item,index))}">
                <i translate="translate" class="material-icons notranslate"> description </i>
              <span>{{item.name}}{{item.ext}}</span>
            </div>
            <span class="input-progress" :style="{width: item.percentCompleted + '%'}" v-if="item.percentCompleted"></span>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            images: Array,
            index: String,
            isDelete: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                items: []
            }
        },
        mounted () {
            this.items = this.images
        },
        methods: {
            getUrl(item) {
              if(this.index ==="thumbnail") return item
              return item.formats && item.formats.thumbnail ? item.formats.thumbnail.url : item.url;
            },
            deleteItem(item, itemIndex) {
                this.$emit('deleteImage', {item: item, index: this.index, itemIndex: itemIndex});
            }
        },
      watch: {
        images(next, prev) {
          if (next !== prev) {
            this.items = next;
            this.currentList = [];
          }
        },
      }
    }
</script>
